import React, { Component } from "react";
// import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { hot } from "react-hot-loader";
import { I18nextProvider, translate } from "react-i18next";
import debounce from "lodash/debounce";

import { initialize as initCart } from "../../store/modules/cart";
import Cart from "./Cart";
import Loader from "../../component/Loader";
import { onWindowScroll, onWindowResize } from "../../store/modules/app";
import i18n from "../../lib/i18n";

import "./Container.scss";

class Container extends Component {
  static propTypes = {
    hasFetched: PropTypes.bool,
    onWindowScroll: PropTypes.func.isRequired,
    onWindowResize: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired
  };

  static defaultProps = {
    hasFetched: false
  };

  componentWillMount = () => {
    this.onScroll = debounce(this.props.onWindowScroll, 50);
    this.onResize = debounce(this.props.onWindowResize, 50);
    window.addEventListener("scroll", this.onScroll);
    window.addEventListener("resize", this.onResize);
  };

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.onResize);
  }

  render() {
    if (!this.props.hasFetched) {
      return (
        <div className="Loader__wrapper d-flex flex-column flex-1 flex-no-shrink justify-content-center align-items-center">
          <Loader
            message={this.props.t("Please wait, delivery options are being checked")}
            messagePosition="right"
            messageClassName="d-flex justify-content-center align-items-center"
          />
        </div>
      );
    }
    return (
      <I18nextProvider i18n={i18n}>
        <Cart />
      </I18nextProvider>
    );
  }
}

export default translate()(
  connect(
    state => ({
      hasFetched:
        state.cart.get("hasFetched", false) &&
        state.cart.get("hasFetchedContext", false) &&
        state.cart.get("hasFetchedSchema", false)
    }),
    {
      initCart,
      onWindowScroll,
      onWindowResize
    }
  )(hot(module)(Container))
);
